import React from 'react';
import ChanceListContainer from '../../containers/chancemng/ChanceListContainer';


const ChanceListPage = () => {
  return <ChanceListContainer/>
};

export default ChanceListPage;
